import { request } from '@/request'

const URLS = {
  reqToken: '/user/login',
  reqUserRegister: '/user/add/Member',
  reqUserInfo: '/user/token/message',
  reqAllAdminInfo: '/gw-serve-clause/admin/selectAll',
  reqUserCountryList: '/m-country-code/getTeacherList',
  reqAgentNameList: '/m-country-code/getTeacherList/Agent'
}

/* 登录获取token和用户信息 */
export const reqToken = (data) => {
  return request.post(URLS.reqToken, data)
}

export const reqUserRegister = (data) => {
  return request.get(`${URLS.reqUserRegister}?account=${data.account}&password=${data.password}&parentId=${data.parentId}&parentId2=${data.parentId2}`)
}

/* 获取用户信息 */
export const reqUserInfo = () => {
  return request.get(URLS.reqUserInfo)
}


/* 请求电话号码 */
export const reqAllAdminInfo = () => {
  return request.get(URLS.reqAllAdminInfo)
}

/* 请求已经开启代理的国家列表 */
export const reqUserCountryList = () => {
  return request.get(URLS.reqUserCountryList)
}

/* 根据国家id 获取代理列表 */
export const reqAgentNameList = (id) => {
  return request.get(`${URLS.reqAgentNameList}?id=${id}`)
}
